import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlColorProps extends ControlTemplateProps {
    
}

export const ControlColor: React.FC<ControlColorProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput {...ComponentProps(props)} type="color" style={{ ...styles.color ?? styles.input, ...props.style }} />        
    );
};